import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import { ChevronRightIcon } from '@heroicons/react/20/solid';

const homeFaqs = [
  {
    question: 'How long is the program?',
    answer: '3 months.',
  },
  {
    question: 'Who qualifies for the program?',
    answer: ' Women entrepreneurs that have a business offline.',
  },
  {
    question: 'Where would the location be?',
    answer: 'Virtual for women across nigeria',
  },
  {
    question: 'Where do i signup for this program',
    answer: 'Start by filling this form https://bit.ly/WE-ElevateNigeria',
  },
];

export default function WeElevateFAQ() {
  return (
    <section className="pt-6 mb-0 pb-0">
      <h1 className="lg-max-w-4xl md-max-w-xl text-3xl lg:text-5xl  text-center text-text-color  tracking-normal font-semibold">
        FAQ{' '}
      </h1>
      <div className="w-full pt-6 lg:pt-10 px-6 lg:px-14">
        <div className="w-full">
          {homeFaqs.map((faq, index) => (
            <Disclosure
              as="div"
              className="rounded-2xl lg:rounded-full bg-light-grey-5 py-6 px-6 lg:px-14 mb-6"
            >
              <DisclosureButton className="group flex w-full items-center justify-between">
                <span className="text-base lg:text-lg font-semibold text-text-color text-left group-data-[hover]:text-primary">
                  {faq.question}
                </span>
                <ChevronRightIcon className="size-5 lg:size-7 fill-black group-data-[hover]:fill-primary group-data-[open]:rotate-180" />
              </DisclosureButton>
              <DisclosurePanel
                transition
                className="mt-3 text-sm lg:text-base text-dark-grey-1 lg:pr-20 transition duration-200 ease-out"
              >
                {faq.answer}
              </DisclosurePanel>
            </Disclosure>
          ))}
        </div>
      </div>
      <hr className="my-10 border-1 border-light-grey-5"></hr>
    </section>
  );
}
